export const max = (values: number[]): number => {
  const maxValue = Math.max(...values);
  return maxValue;
};
